import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/utils/format";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  linkTo?: string;
  linkLabel?: string;
  className?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  linkTo,
  linkLabel = "查看全部",
  className,
  children,
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 md:flex-row md:items-end md:justify-between",
        align === "center" && "md:flex-col md:items-center md:text-center",
        className
      )}
    >
      <div className={cn("max-w-2xl", align === "center" && "mx-auto text-center")}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-xs uppercase tracking-[0.28em] text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-500" aria-hidden="true" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {desc}
          </p>
        )}
      </div>
      {children}
      {linkTo && !children && (
        <Link
          to={linkTo}
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-500"
        >
          {linkLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}